// KeyPressLog.tsx

import React, { useContext } from 'react';
import { GameLog } from '../../../../Logs/LogsDisplay';
import './KeyPressLog.css';
import GameAssetsContext from '../../../../../../context/GameAssetContext';
import { championImages } from './Images/championImages';

interface KeyPressLogProps {
  log: GameLog;
  spellImageUrls: Record<string, string>;
  AutoAttackImage: string;
}

const KeyPressLog: React.FC<KeyPressLogProps> = ({ log, spellImageUrls, AutoAttackImage }) => {
  const { gameWideAssets } = useContext(GameAssetsContext);
  const { itemImages } = gameWideAssets;


  const keyPressType = log.details.keyPressType; 
  // keyPressType can be "Ability", "AutoAttack", or "Item" (assuming we differentiate them like this)
  // If not specified, we can fallback to old logic.

  let imagePath = '';
  let altText = '';
  let displayKey = '';

  if (keyPressType === "Item") {
    // It's an item usage
    const itemId = log.details.itemId;
    if (itemId && itemImages[itemId]) {
      imagePath = itemImages[itemId];
      altText = "Item Active";
      displayKey =
        log.details.itemSlot != null ? log.details.itemSlot.toString() : "";
    } else {
      // Fallback if no item image found
      altText = "Item Active";
    }
  } else {
    // It's an ability or auto-attack
    const abilityKey = log.details.abilityKey?.toLowerCase();
    const isAutoAttack = abilityKey === "a";
    const championName = log.details.championName; // e.g. Aatrox
    const imageState = log.imageState || "default";

    if (isAutoAttack) {
      // Just auto-attack
      imagePath = AutoAttackImage;
      altText = "Auto Attack";
      displayKey = abilityKey || "";
    } else {
      // It's an ability
      altText = abilityKey ? `${abilityKey.toUpperCase()} Ability` : "Ability";
      displayKey = abilityKey || "";

      if (championName && championImages[championName]) {
        const champMap = championImages[championName];
        let finalIconUrl: string | undefined;

        // 1) If imageState != "default", try championImages[championName][imageState]
        if (imageState && imageState !== "default") {
          finalIconUrl = champMap[imageState.toLowerCase()];
        }

        // 2) If still no icon, or imageState was "default", try champMap[abilityKey]
        if (!finalIconUrl && abilityKey) {
          finalIconUrl = champMap[abilityKey];
        }

        // 3) If still no icon, fallback to old approach using spellImageUrls
        if (!finalIconUrl && abilityKey) {
          const upperKey = abilityKey.toUpperCase();
          if (spellImageUrls[upperKey]) {
            finalIconUrl = spellImageUrls[upperKey];
          }
        }

        if (finalIconUrl) {
          imagePath = finalIconUrl;
        }
      } else {
        // If we can't find championName or it doesn't exist in championImages,
        // fallback to old approach
        if (abilityKey) {
          const upperKey = abilityKey.toUpperCase();
          if (spellImageUrls[upperKey]) {
            imagePath = spellImageUrls[upperKey];
          }
        }
      }
    }
  }
  return (
    <div className="ability-container-wrapper" key={log.id}>
      <div className="ability-image-container">
        {imagePath ? (
          <img src={imagePath} alt={altText} className="ability-img" />
        ) : (
          <div className="ability-img fallback-icon">?</div>
        )}
        {displayKey && <div className="ability-letter">{displayKey.toUpperCase()}</div>}
      </div>
    </div>
  );
};

export default KeyPressLog;
